import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import Swiper from 'react-id-swiper'

import { media } from '../../../styles/utils'
import { Link } from 'gatsby'

const BlockSlider = (props) => {
  const { slides, sliderStyles, controls, gallery, image_slider, type } = props
  const [caption, updateCaption] = useState(null)
  const [activeIndex, updateActiveIndex] = useState(0)
  const [swiper, updateSwiper] = useState(null)
  const currentSlides = slides || image_slider || gallery || []
  const canLoop = currentSlides && currentSlides.length > 1

  const hasControls = controls || type === 'image_block'

  const defaultSliderParams = hasControls
    ? {
        slidesPerView: 1,
        spaceBetween: 0,
        freeMode: false,
      }
    : {
        slidesPerView: 'auto',
        spaceBetween: 25,
        freeMode: true,
      }

  const userSliderParams = props.sliderParams || {}
  const { on: userOn = {}, ...restUserSliderParams } = userSliderParams

  const swiperParams = {
    loop: canLoop,
    ...defaultSliderParams,
    ...restUserSliderParams,
    on: {
      ...userOn,
      init: function () {
        if (userOn.init) userOn.init.call(this)
        updateSwiper(this)
        updateActiveIndex(this.realIndex)
      },
      slideChange: function () {
        if (userOn.slideChange) userOn.slideChange.call(this)
        updateActiveIndex(this.realIndex)
      },
    },
  }

  const wrapLink = (link, children) => {
    return <Link to={link}>{children}</Link>
  }

  const renderSlides = () => {
    if (!currentSlides || !currentSlides.length) return

    return currentSlides.map((item, i) => {
      const image = item.image || item
      if (!image) return

      return (
        <Slide key={i}>
          <Image
            className={'slider-image'}
            image={image.sizes ? image.sizes.medium2 : image.url}
          />
        </Slide>
      )
    })
  }

  const renderCaption = (slide) => {
    if (!slide.caption) return

    if (slide.caption_link) {
      return (
        <CaptionLink
          to={slide.caption_link}
          dangerouslySetInnerHTML={{ __html: slide.caption }}
        />
      )
    } else {
      return <Caption dangerouslySetInnerHTML={{ __html: slide.caption }} />
    }
  }

  const renderControls = () => {
    if (!currentSlides || !currentSlides.length) return
    const activeSlide = currentSlides[activeIndex]

    return (
      <Controls>
        <Count>{activeIndex + 1}</Count>

        <PrevNext>
          <Prev onClick={() => swiper && swiper.slidePrev()}>Prev</Prev>

          <Divider>/</Divider>

          <Next onClick={() => swiper && swiper.slideNext()}>Next</Next>
        </PrevNext>

        {activeSlide && renderCaption(activeSlide)}
      </Controls>
    )
  }

  return (
    <Wrapper sliderStyles={sliderStyles}>
      <Swiper {...swiperParams}>
        {(props.renderSlides && props.renderSlides(currentSlides)) ||
          renderSlides()}
      </Swiper>

      {(controls || type === 'image_block') && renderControls()}
    </Wrapper>
  )
}

// Shared

const Description = styled.div``
const InternalLink = styled(Link)``

const Image = styled.div`
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`

// Layout

const defaultSliderStyles = css`
  height: 66vw;
  max-height: 900px;
`

const Wrapper = styled.div`
  position: relative;

  .swiper-container {
    ${(props) => props.sliderStyles || defaultSliderStyles}
  }
`

// Slide

const Slide = styled.div`
  ${Image} {
    height: 100%;
  }
`

// Prev / Next

const Next = styled.div``
const Prev = styled.div``
const Divider = styled.div``

const PrevNext = styled.div`
  display: flex;
  user-select: none;

  ${Divider} {
    margin: 0 7px;
  }

  ${Next},
  ${Prev} {
    cursor: pointer;
  }

  ${media.phone`
		display: none;
	`}
`

// Controls

const Count = styled.div``
const Caption = styled.div``
const CaptionLink = styled(Link)``

const Controls = styled.div`
  display: flex;
  margin-top: 30px;
  opacity: 0.4;

  ${Count} {
    margin-right: 44px;
  }

  ${Caption},
  ${CaptionLink} {
    max-width: 50%;
    width: 100%;
    margin-left: auto;

    a {
      text-decoration: underline;
    }
  }

  ${media.phone`
		font-size: 14px;
		margin-top: 15px;

		${Caption},
		${CaptionLink} {
			max-width: 70%;
		}
	`}
`

BlockSlider.wrapper = css``

export default BlockSlider
